// extracted by mini-css-extract-plugin
export default {"SelectedAssessments":"styles_SelectedAssessments__S8RND","content":"styles_content__CvN0q"};